<template>
    <div>

        <!-- components tabs start -->
        <div class="container-inner mg-top-90">
            <div class="container-fluid">
                <div class="row flex-row">
                    <div class="col-xl-12">
                        <div class="container">
                            <!-- Basic Tabs -->
                            <div class="widget-header text-center">
                                <h4>{{ $route.query.ref }} </h4>
                                <h4>Order <span v-if="order.yourref" v-html="'for ' + order.yourref"></span></h4>
                            </div>
                            <div class="widget has-shadow ">
                                <!-- mg-top-90 -->
                                <div class="table-area ">
                                    <div v-show="!component"class="container">
                                        <!-- <h5>Color Table</h5> -->
                                        <div class="ba-all-page-inner mb-4 p-0 border-radius-4">
                                            <div class="table-responsive" :style="'overflow-x: hidden !important;'">
                                                <d-table
                                                    classdivtable="availtable datatable nested table table-responsive"
                                                    refid="orders" :busy="orders.busy" :icon="orders.icon"
                                                    :icons="orders.icons" :toolbarlibrary="orders.toolbarlibrary"
                                                    :tools="orders.tools" :fields="orders.fields"
                                                    :badges="orders.badges" :items="orders.items"
                                                    :downloaded="orders.downloaded" :showpages="false"
                                                    :selectmode="'single'" :maxheight="2000" @select="orders_select"
                                                    @click="orders_click" @load="orders_load"></d-table>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-show="component">
                                        <component :is="component" :selection="orders.selected" :config="cconfig"
                                            @discard="orders_click('discard')">
                                        </component>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Basic Tabs -->
            </div>
        </div>
    </div>
    <!-- </div>
    </div> -->
    <!-- </div> -->

</template>

<script>
import gql from "graphql-tag";

import OrdersEdit from "./Components/OrdersEdit";

import * as fs from "file-saver";

export default {
    components: { OrdersEdit },
    name: "Orders",
    data() {
        return {
            order: {},
            orders: {
                debounce: 500,
                busy: false,
                icon: "fa fa-gbp",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-line-chart text-primary mr-1",
                        position: "toolbar",
                        action: "spent",
                        label: "Spent",
                        component: {
                            name: "",
                        },
                    },
                ],
                tools: "go,download,add,edit,deleteconfirm,spent",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-35px text-primary",
                    },
                    {
                        key: "placed_at",
                        label: "Date",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        }
                    },
                    {
                        key: "yourref",
                        label: "Your Ref / PO",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = value;
                            if (value.length >= 30) {
                                result = value.slice(0, 27) + " ...";
                            }
                            return result;
                        },
                    },

                    // {
                    //   key: "eventcode",
                    //   label: "Event",
                    //   sortable: true,
                    //   class: "d-none d-xl-table-cell",
                    // },
                    {
                        key: "eventname",
                        label: "Name",
                        sortable: true,
                        class: "d-none d-xl-table-cell",
                        formatter: (value, key, item) => {
                            if (value) {
                                let result = value;
                                if (value.length >= 30) {
                                    result = value.slice(0, 27) + " ...";
                                }
                                return result;
                            }
                        },
                    },
                    {
                        key: "value",
                        label: "Value",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "spent",
                        label: "Spent",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "reclaim",
                        label: "Reclaim",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "remaining",
                        label: "Remaining",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        totalled: true,
                        total: 0,
                    },
                    // {
                    //     key: "progress",
                    //     label: "Progress%",
                    //     sortable: true,
                    //     class: "d-none d-xl-table-cell",
                    // },
                    // {
                    //     key: "used",
                    //     label: "Used%",
                    //     sortable: true,
                    //     class: "d-none d-xl-table-cell",
                    //     formatter: (value, key, item) => {
                    //         let result = "0";
                    //         if (item.spent && item.value) {
                    //             if (parseFloat(item.spent) > 0 && parseFloat(item.value) > 0) {
                    //                 result = ((parseFloat(item.spent) / parseFloat(item.value)) * 100).toFixed(2)
                    //             }
                    //         }
                    //         return result;
                    //     }
                    // },
                    // {
                    //     key: "notify_limit",
                    //     label: "Notify%",
                    //     sortable: true,
                    //     class: "d-none d-xl-table-cell",
                    // },
                    // {
                    //     key: "status",
                    //     label: "Status",
                    //     class: "d-none d-sm-table-cell",
                    //     sortable: true,
                    // },
                    // {
                    //     key: "agent",
                    //     label: "Agent",
                    //     sortable: true,
                    //     class: "d-none d-sm-table-cell",
                    // },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "text-center actions w-80px",
                    },
                ],
                icons: [
                    {
                        key: "credit",
                        invoice: "fa fa-long-arrow-up text-warning w-15px text-center",
                        credit: "fa fa-long-arrow-down text-gray w-15px text-center",
                    }
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                component: null,
            },
            fill: { gradient: ["green"] },
        }
    },
    watch: {
        "$route.query.id": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('$route.query.id', newVal)
                await this.orders_load(0)
            }
        }
    },
    methods: {
        async orders_load(offset, limit, page) {

            // if (!this.$route.query.id) { return }

            let state = this.orders;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                slac: this.user.slac
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query orders( $limit: Int
              $offset: Int
              $id: String
              $dateplaced_at: [String]
              $slac: String
              $yourref: String
              $eventcode: String
              $agent: String
              $status: String) {
                        orders(limit: $limit
                offset: $offset
                id: $id
                dateplaced_at: $dateplaced_at
                yourref: $yourref
                slac: $slac
                eventcode: $eventcode
                agent: $agent
                status: $status) {
                           id
                            yourref
                            slac
                            reason
                            placed_at
                            eventcode
                            eventname
                            value
                            spent
                            reclaim
                            credit
                            remaining
                            notify_limit
                            forecast
                            forecast_on #needed for donuts
                            notes
                            status
                            attachment
                            agent
                            updated_by
                            updated_at
                            rows
                            # }
                        }
                        }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });


                if (response.data.orders.length > 0) {
                    // this.order = response.data.orders[0]
                    this.orders.items = response.data.orders
                }
                // for (var j = 0; j < this.orders.items.length; ++j) {
                //     this.orders.items[j].credit = this.orders.items[j].credit == true ? 'credit' : 'invoice'
                //     //     if (this.orders.items[j].evat == "0.00") {
                //     //         let saletotal = this.orders.items[j].saletotal
                //     //         this.orders.items[j].evat = (parseFloat(saletotal) - (parseFloat(saletotal) / 1.2)).toFixed(2)
                //     //     }
                // }


                // this.ordersother.items = response.data.orders[0].orders_other;

                // state.downloaded = []
                // if (limit == 0) {
                //     state.downloaded = response.data.bankingsimports
                // } else {
                //     state.items = response.data.bankingsimports;
                // }

            } catch (error) {
                console.log(error);
            }
            this.message = ""
            state.edit = false
            state.busy = false;
        },
        async orders_click(a, ss) {
            console.log('orders_click', a, ss)

            let state = this.orders;

            switch (a) {
                case "selectall":
                    break;
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    // await this.bankingsimports_load(0);
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.errormessage = ""
                    this.component = null
                    // await this.bankingsimports_load(0)
                    break;
                case "go":
                    this.errormessage = ""
                    await this.orders_load(0)
                    break;
                case "add":
                    this.component = "OrdersEdit";
                    break;
                case "edit":
                    this.component = "OrdersEdit";
                    break;

                case "rename":
                    if (ss.length > 0) {
                        state.item = { ...ss[0] }
                    }
                    state.rename = !state.rename
                    break;
                case "import":
                    this.fileUpload = null
                    this.suggestedname = ""
                    state.importshow = !state.importshow
                    break;
                case "saveas":
                    // await this.bankingsimports_saveas(ss);
                    break;
                case "redo":
                    // await this.bankingsimports_redo(ss);
                    break;
                case "reorder":
                    // await this.bankingsimports_reorder(ss);
                    break;
                case "delete":
                    await this.orders_deleteit(ss);
                    break;
                case "spent":
                    await this.orders_spent(ss);
                    break;

            }
        },
        async orders_select(ss, tools) {

            let state = this.orders;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "import", "download", "add"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "saveas"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm", "spent"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });

                if (state.selected.length > 0) {
                    state.item = state.selected[0]  // WHAT YOU SELECTED

                    let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.date_at != 'NaN') {
                        v = this.$moment.unix(state.item.date_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    state.datefor_date_at = { startDate: v, endDate: v }
                } else {
                    state.item = {}
                }
            }
        },

        async orders_deleteit(ss) {
            console.log("orders_deleteit", ss);

            let state = this.orders;
            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation orders_delete($rows: [Order_input]) {
              orders_delete(rows: $rows) {
                id
              }
            }
          `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }
            state.busy = false
            await this.orders_load();
        },

        async orders_spent(ss) {

            if (ss.length == 0) { return }

            this.orders.busy = true;

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });
            let variables = {
                selected: rows,

            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query orders_spent($selected: [Order_input]) {
              orders_spent(selected: $selected)
            }
          `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }
            this.orders.busy = false;
            await this.orders_load();
        },

    }
}
</script>